import { render, staticRenderFns } from "./fenxijieguo.vue?vue&type=template&id=3d4bcbc8&scoped=true"
import script from "./fenxijieguo.vue?vue&type=script&lang=js"
export * from "./fenxijieguo.vue?vue&type=script&lang=js"
import style0 from "./fenxijieguo.vue?vue&type=style&index=0&id=3d4bcbc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bcbc8",
  null
  
)

export default component.exports